import { Box, Button, IconButton, useClipboard, useColorModeValue } from "@chakra-ui/react";
import { BsClipboard2CheckFill, BsClipboardFill } from "react-icons/bs";
import { LuCopy, LuCopyCheck } from "react-icons/lu";

export default function CodeHighlighting({text="Du texte à l'intérieur", wrap=true, light=false}: {text: string, wrap?: boolean, light?: boolean}) {
    const { onCopy, value, hasCopied } = useClipboard(text)
    const defaultbg = useColorModeValue("gray.700", "gray.600")

    return (
        <Box position="relative" borderRadius="7px" p={light ? 3 : 5} pr={12} bg={light ? "" : defaultbg} border={"1px solid"} borderColor="gray.300">
            <IconButton icon={hasCopied ? <LuCopyCheck /> : <LuCopy />} fontSize={20} variant="link" color={light ? "gray.600" : "white"} onClick={onCopy} size="sm" position="absolute" right="3" top="3" aria-label={"Copy button"}>
            </IconButton>
            <Box textColor={light ? "black" : "white"} overflow="auto">
                <pre style={ wrap ? {whiteSpace: "pre-wrap", wordBreak: "keep-all"} : {} }>
                    <code>
                        { value }
                    </code>
                </pre>
            </Box>
        </Box>
    )
}